import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Languages } from '../classes/infrastructure/enums';
import { BehaviorSubject } from 'rxjs';
import { ServiceInjector } from '../classes/infrastructure/injector';

@Injectable({ providedIn: 'root' })
export class LanguageService {

   public static GetInstance(): LanguageService {
      return ServiceInjector.AppInjector.get(LanguageService);
    }

  private readonly STORAGE_KEY = 'app_lang';

  private langSubject = new BehaviorSubject<'en' | 'mr'>(
    (sessionStorage.getItem('app_lang') as 'en' | 'mr') || 'en'
  );

  lang$ = this.langSubject.asObservable();

  get currentLang(): 'en' | 'mr' {
    return this.langSubject.value;
  }

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('en');
    this.translate.use(this.currentLang);
  }

  switchLanguage(lang: 'en' | 'mr'): void {
    this.langSubject.next(lang);
    this.translate.use(lang);
    sessionStorage.setItem(this.STORAGE_KEY, lang);
  }

  toggle(): void {
    this.switchLanguage(this.currentLang === 'en' ? 'mr' : 'en');
  }

  setLanguageFromPreference(preference: number): void {
    this.switchLanguage(preference === Languages.Marathi ? 'mr' : 'en');
  }

}